import { coreSettings, initializeUtilsCore } from 'app-components/utils/core';

import './configInit';
import platform from './platform';

initializeUtilsCore({ platform, localStorage });
coreSettings.fetchDebounceTimeout = 3000;
